export default "__VITE_ASSET__ClD0OXS6__"